import { PaymentLocalizationForm } from 'components/forms';

const FinancesPaymentLocalizationEdit = () => (
  <PaymentLocalizationForm isEdit />
);

export default FinancesPaymentLocalizationEdit;